import React from 'react';
import { FormInstance, Space } from 'antd';
import { Switch, Text, TextArea, Form } from '@common/components';
import { Colors } from '@common/tokens';

export type FormValues = {
  requireStaffingRequestDocument: boolean;
  staffingRequestDocumentNote: string;
  requireExtensionOfferDocument: boolean;
  extensionOfferDocumentNote: string;
};

type Props = {
  form: FormInstance<FormValues>;
  initialValues: FormValues;
  onFormFinish: () => void;
  onFormChange: () => void;
};

export function ApprovalsConfigsDrawerForm({
  form,
  initialValues,
  onFormFinish,
  onFormChange,
}: Props) {
  const displaySRNote = Form.useWatch('requireStaffingRequestDocument', form);
  const displayEONote = Form.useWatch('requireExtensionOfferDocument', form);

  const RightLabelledSwitchFormItem = ({
    name,
    label,
  }: {
    name: string;
    label: string;
  }) => (
    <Form.Item
      name={name}
      label={label}
      valuePropName="checked"
      style={{ margin: 0 }}
      colon={false}
      labelCol={{ order: 1 }}
      wrapperCol={{ flex: 'none' }}
    >
      <Switch style={{ marginRight: '8px' }} />
    </Form.Item>
  );

  return (
    <Form
      form={form}
      initialValues={initialValues}
      onFinish={onFormFinish}
      onValuesChange={onFormChange}
      preserve
    >
      <div className="approvals-configs-drawer__frame">
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <RightLabelledSwitchFormItem
            name="requireStaffingRequestDocument"
            label="Staffing Requests"
          />
          {displaySRNote && (
            <>
              <Text>
                Require users to upload an attachment when submitting a staffing
                request.
              </Text>
              <Form.Item
                name="staffingRequestDocumentNote"
                style={{ margin: 0 }}
              >
                <TextArea
                  title="Note"
                  placeholder="Add a note users will see upon uploading (non-required)"
                />
              </Form.Item>
            </>
          )}
        </Space>
      </div>
      <div className="approvals-configs-drawer__frame">
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <RightLabelledSwitchFormItem
            name="requireExtensionOfferDocument"
            label="Extensions"
          />
          {displayEONote && (
            <>
              <Text>
                Require users to upload an attachment when submitting an
                extension
              </Text>
              <Form.Item
                name="extensionOfferDocumentNote"
                style={{ margin: 0 }}
              >
                <TextArea
                  title="Note"
                  placeholder="Add a note users will see upon uploading (non-required)"
                />
              </Form.Item>
            </>
          )}
        </Space>
      </div>
      <style jsx>
        {`
          .approvals-configs-drawer__frame {
            border: 1px solid ${Colors.steelLighter};
            border-radius: 4px;
            padding: 16px;
            margin-bottom: 16px;
          }
        `}
      </style>
    </Form>
  );
}
